module.exports = __webpack_public_path__ + "static/img/sensor_chuva-1.e6150c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensor_chuva-1.svg
// module id = 3lDc
// module chunks = 0